import type { ExtractPutRoutes, RouteSegment } from '@openclassrooms/sdk';
import useMutationRequest from './useMutationRequest';
import type { ApiRoutes, PutRequestBuilder, RequestOption, MutateOptions } from '../types';
export default function usePut(path, mutationOptions) {
  return useMutationRequest("PUT", path, mutationOptions);
}